import { accessorHandler, createNamedProxy } from "../utils";

export const borderRadius = {
  large: '20px',
  default: '10px',
  small: '5px',
} as const;

export const proxy: typeof borderRadius = createNamedProxy('borderRadius', borderRadius, accessorHandler)
